export enum Layout {
  FULL_PAGE = 'full-page',
  SIDE_NAVIGATION = 'side-navigation',
}
